module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-greek608.436683c.woff2";